<template>
    <app-modal unique="add-country" title="Add Country">
        <form @submit.prevent="confirmAddCountry">
            <div class="form-group form-row mb-1" :class="{'has-error': newCountryErrors.code}">
                <label for="new-country-code" class="col col-sm-4 col-form-label font-weight-bolder text-right">
                    Country Code:
                </label>
                <div class="col col-sm-8 col-form-label p-0">
                    <input type="text" id="new-country-code" class="form-control form-control-xs"
                           placeholder="Enter Country Code Here"
                           v-model="newCountry.code"
                    >
                    <span class="help-block" v-if="newCountryErrors.code !== ''">
                      <small><strong>{{ newCountryErrors.code }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': newCountryErrors.name}">
                <label for="new-country-name" class="col col-sm-4 col-form-label font-weight-bolder text-right">
                    Country Name:
                </label>
                <div class="col col-sm-8 col-form-label p-0">
                    <input type="text" id="new-country-name" class="form-control form-control-xs"
                           placeholder="Enter Country Name Here"
                           v-model="newCountry.name"
                    >
                    <span class="help-block" v-if="newCountryErrors.name !== ''">
                      <small><strong>{{ newCountryErrors.name }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': newCountryErrors.natl}">
                <label for="new-country-nationality" class="col col-sm-4 col-form-label font-weight-bolder text-right">
                    Nationality:
                </label>
                <div class="col col-sm-8 col-form-label p-0">
                    <input type="text" id="new-country-nationality" class="form-control form-control-xs"
                           placeholder="Enter Nationality Here"
                           v-model="newCountry.natl"
                    >
                    <span class="help-block" v-if="newCountryErrors.natl !== ''">
                      <small><strong>{{ newCountryErrors.natl }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': newCountryErrors.natl_code}">
                <label for="new-nationality-code" class="col col-sm-4 col-form-label font-weight-bolder text-right">
                    Nationality Code:
                </label>
                <div class="col col-sm-8 col-form-label p-0">
                    <input type="text" id="new-nationality-code" class="form-control form-control-xs"
                           placeholder="Enter Nationality Code Here"
                           v-model="newCountry.natl_code"
                    >
                    <span class="help-block" v-if="newCountryErrors.natl_code !== ''">
                      <small><strong>{{ newCountryErrors.natl_code }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': newCountryErrors.active }">
                <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="new-country-status" >
                    Status:
                </label>

                <div class="col col-sm-8">
                    <div class="form-check d-block">
                      <select class="form-control form-control-xs" id="new-country-status" v-model="newCountry.active">
                        <option value="">Select..</option>
                        <option :value="1" >ACTIVE</option>
                        <option :value="0">INACTIVE</option>
                      </select>
                    </div>
                    <span class="help-block" v-if="newCountryErrors.active !== ''">
                    <small><strong>{{ newCountryErrors.active }}</strong></small>
                </span>
                </div>
            </div>

            <hr />
            <div class="text-right">
                <button type="submit" class="btn btn-outline-primary btn-sm btn-xs font-weight-bolder" v-if="!guest">
                    <i class="fas fa-save mr-1"></i>Save
                </button>
            </div>

        </form>
    </app-modal>
</template>

<script>
/* eslint-disable */
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { formMixin } from "@/mixins/formMixin";
import { gateMixin } from "@/mixins/gateMixin";
import { mapActions, mapGetters} from "vuex";
import AppModal from "@/components/elements/AppModal";

export default {
    name: "AddCountry",

    components: { AppModal },

    mixins: [ vueAppMixin, formMixin, gateMixin ],

    data() {
        return {
            newCountry: {
              active: ''
            },
            newCountryErrors: {}
        }
    },

    methods: {
        ...mapActions([
            'addCountry'
        ]),

        async confirmAddCountry() {
            if(await this.confirmCreateAlert()) {
                let newCountry = await this.addCountry(this.newCountry);
                if(newCountry) {
                    if(newCountry.errors) {
                        this.newCountryErrors = newCountry.errors;
                    } else {
                        this.successAlert('Country Successfully Saved', 'CREATE');
                        document.getElementById('close-add-country').click();
                        this.newCountryErrors = {};
                        this.newCountry = {};
                    }
                } else {
                    this.errorAlert('Country Failed to Save', 'CREATE')
                }
            }
        }

    }

}
</script>

<style scoped>

</style>
